import { render, staticRenderFns } from "./intell_answer.vue?vue&type=template&id=3524ff8e&scoped=true"
import script from "./intell_answer.vue?vue&type=script&lang=js"
export * from "./intell_answer.vue?vue&type=script&lang=js"
import style0 from "./intell_answer.vue?vue&type=style&index=0&id=3524ff8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3524ff8e",
  null
  
)

export default component.exports